// Shared between the admin Dashboard summary card and the full Recipient
// editor — both need to warn about the same "receiving until" date
// (functions/lib/db.ts's isCurrentlyReceivingMail is the server-side
// enforcement; this is just the admin-facing heads-up).
const SOON_THRESHOLD_DAYS = 7;

export interface ExpiryStatus {
  kind: "expired" | "soon";
  message: string;
}

export function getExpiryStatus(location: { valid_until: string | null; receiving_mail: number }): ExpiryStatus | null {
  if (!location.valid_until) return null;
  const expiry = new Date(location.valid_until);
  const daysLeft = Math.ceil((expiry.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  const formatted = expiry.toLocaleDateString("en-GB");

  if (daysLeft < 0) {
    return {
      kind: "expired",
      message: `Receiving until ${formatted} has passed — the public wizard has automatically stopped offering to send, even though "Receiving post" is still set to ${location.receiving_mail ? "Yes" : "No"}. Update the destination or extend the date.`,
    };
  }
  if (daysLeft <= SOON_THRESHOLD_DAYS) {
    return {
      kind: "soon",
      message: `Receiving until ${formatted} — ${daysLeft === 0 ? "today" : `in ${daysLeft} day${daysLeft === 1 ? "" : "s"}`}. Update this before then, or the wizard will automatically stop offering to send.`,
    };
  }
  return null;
}
